/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionEventModelDto } from '../../models/vision-event-model-dto';

export interface VisionEventsControllerGetEvents$Params {
  uuid: string;
}

export function visionEventsControllerGetEvents(http: HttpClient, rootUrl: string, params: VisionEventsControllerGetEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VisionEventModelDto>>> {
  const rb = new RequestBuilder(rootUrl, visionEventsControllerGetEvents.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VisionEventModelDto>>;
    })
  );
}

visionEventsControllerGetEvents.PATH = '/match-videos/{uuid}/events';
